import Vue from "vue";
import VueRouter from "vue-router";
import LoginUser from "../components/LoginUser.vue";
import reset_passwd from "../components/reset_passwd.vue";
import request_passwd_change from "../components/request_passwd_change.vue";
import licenses from "../views/licenses.vue";
import licenses_v3 from "../views/licenses_v3.vue";
import admin_licenses_v3 from "../views/admin_licenses_v3.vue";
import subscriptions_v3 from "../views/subscriptions_v3.vue";
import br_releases from "../views/br_releases.vue";
import user_subscriptions_v3 from "../views/user_subscriptions_v3.vue";
import settings from "../views/settings.vue";
import store from "../store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    redirect: "/licenses"
  },
  {
    path: "/login",
    name: "login",
    component: LoginUser
  },
  {
    path: "/reset_passwd/:otp",
    name: "reset_passwd",
    component: reset_passwd
  },
  {
    path: "/request_passwd_change",
    name: "request_passwd_change",
    component: request_passwd_change
  },
  {
    path: "/settings",
    name: "settings",
    component: settings
  },
  {
    path: "/logout",
    name: "logout",
    component: {
      beforeRouteEnter(to, from, next) {
        store.dispatch("logout");
        return next("/login");
      }
    }
  },
  {
    path: "/licenses",
    name: "licenses",
    component: licenses
  },
  {
    path: "/licenses_v3",
    name: "licenses_v3",
    component: licenses_v3
  },
  {
    path: "/subscriptions_v3",
    name: "user_subscriptions_v3",
    component: user_subscriptions_v3
  },
  {
    path: "/admin/licenses_v3",
    name: "admin_licenses_v3",
    component: admin_licenses_v3,
    meta: { admin: true }
  },
  {
    path: "/admin/subscriptions_v3",
    name: "subscriptions_v3",
    component: subscriptions_v3,
    meta: { admin: true }
  },
  {
    path: "/admin/br_releases",
    name: "br_releases",
    component: br_releases,
    meta: { admin: true }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const public_pages = ["/login", "/reset_passwd", "/request_passwd_change"];
  var auth_required = true;
  for (var i = 0; i < public_pages.length; i++)
    if (to.path.includes(public_pages[i])) {
      auth_required = false;
      break;
    }
  const authenticated = store.state.auth;

  // redirect to login page if user is not logged in and trying to access a restricted page
  if (auth_required && !authenticated) {
    return next("/login");
  }

  // Redirect admin paths to /licenses for non-admin users.
  if (to.matched.some(record => record.meta.admin)) {
    if (!store.getters.is_admin) return next("/licenses");
  }

  next();
});

export default router;
